/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MUploadMetaComponent as ɵa} from './upload-meta.component';